<template>
  <div id="side-sns" class="widget sns">
    <social-sharing :url="this.url" :title="this.title" description="" quote="" hashtags="" twitter-user="nobi_lab"
      inline-template :networks="overriddenNetworks">
      <div class="wrap">
        <network network="facebook">
          <i class="icon-facebook"></i>
        </network>
        <network network="line">
          <i class="icon-line"></i>
        </network>
        <network network="twitter">
          <i class="icon-twitter"></i>
        </network>
        <network network="hatena">
          <i class="icon-hatenabookmark"></i>
        </network>
        <network network="pocket">
          <i class="icon-pocket"></i>
        </network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
  // import { mapGetters } from "vuex";

  export default {
    props: [],
    data() {
      let param = this.getParam();
      return {
        url: param.url,
        title: param.title,
        overriddenNetworks: {
          "hatena": {
            "sharer": "https://b.hatena.ne.jp/add?mode=confirm&title=@title&url=@url",
            "type": "popup"
          },
          "pocket": {
            "sharer": "https://getpocket.com/edit?url=@url&title=@title",
            "type": "popup"
          }
        }
      };
    },
    methods: {
      getParam() {
        let current_route = this.$router.currentRoute;
        let url = location.origin + current_route.path;
        let title = window.document.title;
        return {
          url: url,
          title: title
        };
      },
    },
    watch: {
      '$route'() {
        let param = this.getParam();
        this.url = param.url;
        this.title = param.title;
        // this.overriddenNetworks = this.getOverriddenNetworks()
      },
    },
    computed: {
      // ...mapGetters({
      //   somePages: "somePages",
      //   allPagesLoaded: "allPagesLoaded"
      // })
    },

    mounted() {}
  };
</script>